/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {DumpsterFire} from "../DumpsterFire";
import {gsap} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class DumpsterFireBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundContainer: PIXI.Container;
    public mainBackgroundSpine: PIXI.spine.Spine;
    public fsBackgroundSpine: PIXI.spine.Spine;
    private _mainView: PIXI.Container;
    private _frameSpineArray: PIXI.Sprite[] = [];
    private _upgradedScatter: PIXI.Sprite;
    private _upgradedXWays: PIXI.Sprite;
    private _upgradedXBomb: PIXI.Sprite;
    private _upgradedScatterGlow: PIXI.Sprite;
    private _upgradedXWaysGlow: PIXI.Sprite;
    private _upgradedXBombGlow: PIXI.Sprite;
    private _idleTl: gsap.core.Timeline;
    private _idleAnimCounter: number = 0;
    private _idleAnimationsName: string = DumpsterFire.apiPlugin.gameClientConfiguration.useCensoredGfxUS && !DumpsterFire.model.isFreespin ? "idle_landscape_US" : "idle_landscape";
    private _upgradePlaceholder: PIXI.Sprite;

    constructor() {
        super();
        this.name = "DumpsterFireBackgroundElements";
        this.init();
    }

    public onOrientationChanged() {

    }

    public onResize() {
        if (NolimitApplication.isLandscape) {
            this._upgradedScatter.position.set(794, 323);
            this._upgradedXBomb.position.set(794, 238);
            this._upgradedXWays.position.set(794, 156);
            this._upgradedScatterGlow.position.set(794, 323);
            this._upgradedXBombGlow.position.set(796, 239);
            this._upgradedXWaysGlow.position.set(794, 156);
            if (!DumpsterFire.model.isFreespin) {
                this._idleAnimationsName = DumpsterFire.apiPlugin.gameClientConfiguration.useCensoredGfxUS ? "idle_landscape_US" : "idle_landscape";
            } else {
                this._idleAnimationsName = "idle_landscape";
            }
        } else {
            this._upgradedScatter.position.set(450, 10);
            this._upgradedXBomb.position.set(362, 10);
            this._upgradedXWays.position.set(285, 10);
            this._upgradedScatterGlow.position.set(450, 10);
            this._upgradedXBombGlow.position.set(363, 10);
            this._upgradedXWaysGlow.position.set(285, 10);
            if (!DumpsterFire.model.isFreespin) {
                this._idleAnimationsName = DumpsterFire.apiPlugin.gameClientConfiguration.useCensoredGfxUS ? "idle_portrait_US" : "idle_portrait";
            } else {
                this._idleAnimationsName = "idle_portrait";
            }
        }
        if (DumpsterFire.model.isFreespin) {
            this._upgradePlaceholder.visible = !NolimitApplication.isLandscape;
        }
    }

    public resetIdleTimeline(): void {
        if (this._idleTl !== undefined) {
            this._idleTl.pause().kill();
        }
    }

    public setIdleTimeline(): void {
        let mode: PIXI.spine.Spine = DumpsterFire.backgroundElements.mainBackgroundSpine;
        if (DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1 && !(DumpsterFire.model.data.nextMode.indexOf("NORMAL") > -1) && DumpsterFire.model.isFreespin) {
            mode = DumpsterFire.backgroundElements.fsBackgroundSpine;
        }
        this._idleTl = new gsap.core.Timeline({});
        this._idleTl.add(() => {
            let animIndex: number = this._idleAnimCounter;
            while (animIndex == this._idleAnimCounter) {
                animIndex = Math.floor(Math.random() * this._idleAnimationsName.length);
            }
            this._idleAnimCounter = animIndex;
            const trackNum: number = 1000 + animIndex;
            this.onResize();
            Logger.logDev("Idle animations played : ", this._idleAnimationsName[animIndex], " at Track : ", trackNum);
            mode.state.setAnimation(trackNum, this._idleAnimationsName, false);
        }, Math.random() * (8) + 1);
        this._idleTl.add(() => {
            this.setIdleTimeline();
        }, '>');
    }

    public activeUpgradedSymbol(): void {
        this.disableUpgradedSymbol();
        [
            {symbol: "S", element: this._upgradedScatter},
            {symbol: "XB", element: this._upgradedXBomb},
            {symbol: "XW", element: this._upgradedXWays}
        ].forEach(({symbol, element}) => {
            if (DumpsterFire.model.findUpgradedSymbol(symbol)) {
                element.visible = true;
            }
        });
        [
            {symbol: "S", element: this._upgradedScatterGlow},
            {symbol: "XB", element: this._upgradedXBombGlow},
            {symbol: "XW", element: this._upgradedXWaysGlow}
        ].forEach(({symbol, element}) => {
            if (DumpsterFire.model.findUpgradedSymbol(symbol)) {
                element.visible = true;
            }
        });
    }

    public setMode(mode: string) {
        const isFreeSpin = mode.indexOf("FREESPIN") > -1;
        const isExtraSpin = mode.indexOf("EXTRA_SPIN") > -1;
        const isNormalMode = DumpsterFire.model.data.mode.indexOf("NORMAL") > -1;
        const hasUpgradedSymbols = DumpsterFire.model.data.upgradedSymbols.length > 0;

        // If mode contains "FREESPIN" or "EXTRA_SPIN" and upgraded symbols exist
        if ((isFreeSpin || (isExtraSpin && DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1)) && hasUpgradedSymbols) {
            this._upgradedScatter.visible = true;
            this.activeUpgradedSymbol();
            this.swapBackgroundTo(this.fsBackgroundSpine);
            if (!NolimitApplication.isLandscape) {
                this._upgradePlaceholder.visible = true;
            }
        }
        // If mode contains "EXTRA_SPIN" but is in "NORMAL" mode
        else if (isExtraSpin && isNormalMode) {
            this._upgradedScatter.visible = false;
            this._upgradePlaceholder.visible = false;
            this.disableUpgradedSymbol();
            this.swapBackgroundTo(this.mainBackgroundSpine);
        }
        // Default case (handles "NORMAL" mode and others)
        else {
            this._upgradedScatter.visible = false;
            this._upgradePlaceholder.visible = false;
            this.disableUpgradedSymbol();
            this.swapBackgroundTo(this.mainBackgroundSpine);
        }
    }

    public removeFrameLoop(): void {
        this._frameSpineArray.forEach((item: PIXI.Sprite) => {
            this.removeChild(item);
        })
    }

    private disableUpgradedSymbol(): void {
        this._upgradedScatter.visible = false;
        this._upgradedXWays.visible = false;
        this._upgradedXBomb.visible = false;
        this._upgradedScatterGlow.visible = false;
        this._upgradedXWaysGlow.visible = false;
        this._upgradedXBombGlow.visible = false;
    }

    private init() {
        this._mainView = new PIXI.Container();
        this._backgroundContainer = new PIXI.Container();

        this.mainBackgroundSpine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("bg"));
        let animName: string = DumpsterFire.apiPlugin.gameClientConfiguration.useCensoredGfxUS ? "idle_landscape_US" : "idle_landscape";
        this.mainBackgroundSpine.state.setAnimation(0, animName, false);
        this.mainBackgroundSpine.position.set(360, 362);
        this.mainBackgroundSpine.name = "mainBackgroundCharacter";

        this._upgradedScatter = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("upgradedScatter")[0]);
        this._upgradedScatter.scale.set(0.5);
        this._upgradedScatter.anchor.set(0.5);
        this._upgradedScatter.visible = false;

        this._upgradedScatterGlow = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("xshotGlow")[0]);
        this._upgradedScatterGlow.scale.set(0.4);
        this._upgradedScatterGlow.anchor.set(0.5);
        this._upgradedScatterGlow.visible = false;

        this._upgradedXBomb = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("upgradedXbomb")[0]);
        this._upgradedXBomb.scale.set(0.5);
        this._upgradedXBomb.anchor.set(0.5);
        this._upgradedXBomb.visible = false;

        this._upgradedXBombGlow = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("xbombGlow")[0]);
        this._upgradedXBombGlow.scale.set(0.4);
        this._upgradedXBombGlow.angle = -166
        this._upgradedXBombGlow.anchor.set(0.5);
        this._upgradedXBombGlow.visible = false;

        this._upgradedXWays = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("upgradedXways")[0]);
        this._upgradedXWays.scale.set(0.5);
        this._upgradedXWays.anchor.set(0.5);
        this._upgradedXWays.visible = false;

        this._upgradedXWaysGlow = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("xwaysGlow")[0]);
        this._upgradedXWaysGlow.scale.set(0.4);
        this._upgradedXWaysGlow.angle = -60
        this._upgradedXWaysGlow.anchor.set(0.5);
        this._upgradedXWaysGlow.visible = false;

        this.fsBackgroundSpine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("bg_fs"));
        this.fsBackgroundSpine.state.setAnimation(0, "animation", false);
        this.fsBackgroundSpine.position.set(360);
        this.fsBackgroundSpine.name = "fsBackgroundCharacter";

        this._upgradePlaceholder = new PIXI.Sprite(DumpsterFire.assetLoader.getTextures("upgrade_base")[0]);
        this._upgradePlaceholder.position.set(237, -40);
        this._upgradePlaceholder.visible = false;
        this._upgradePlaceholder.name = "upgradePlaceholder";

        this._backgroundContainer.addChild(this.mainBackgroundSpine);
        this._backgroundContainer.position.set(3, 0);

        this._mainView.addChild(this._backgroundContainer);
        this.addChild(this._mainView, this._upgradePlaceholder, this._upgradedScatter, this._upgradedXBomb, this._upgradedXWays, this._upgradedScatterGlow, this._upgradedXBombGlow, this._upgradedXWaysGlow);

        this.onOrientationChanged();
        this.onResize();
    }

    private swapBackgroundTo(newBackground: PIXI.spine.Spine) {
        this._backgroundContainer.addChildAt(newBackground, 0);
        if (this._backgroundContainer.children.length > 1) {
            this._backgroundContainer.removeChildren(1);
        }
    }
}